"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { ArrowRight, Sparkles } from "lucide-react";
export function FinalCtaSection() {
  return <section className="py-20 px-6 bg-gradient-to-br from-primary-dark to-primary relative overflow-hidden" data-unique-id="8a13f9bf-cefb-4108-8c94-e65a5b4a9337" data-file-name="components/final-cta-section.tsx" data-dynamic-text="true">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-unique-id="bd3c694e-9302-4403-a248-feb6e0c92c9f" data-file-name="components/final-cta-section.tsx">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="space-y-8" data-unique-id="e124f329-4e30-4d93-a788-9d37fdc0e765" data-file-name="components/final-cta-section.tsx">
          <div className="space-y-4" data-unique-id="858a76e9-8d8c-41ff-9e4f-102223908796" data-file-name="components/final-cta-section.tsx">
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} viewport={{
            once: true
          }} className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 text-white/80 text-sm" data-unique-id="d9927f86-a40e-4dcd-82f6-6820c3a7c63b" data-file-name="components/final-cta-section.tsx">
              <Sparkles className="w-4 h-4" /><span className="editable-text" data-unique-id="d8a8a349-17b5-4095-985d-90e5a644b738" data-file-name="components/final-cta-section.tsx">
              Join thousands of strategic thinkers
            </span></motion.div>
            
            <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight" data-unique-id="0cca20ba-f020-43c3-8344-2ba020c3fece" data-file-name="components/final-cta-section.tsx"><span className="editable-text" data-unique-id="6fb7ab93-249a-4838-9cf2-0b7ea94d184a" data-file-name="components/final-cta-section.tsx">
              Ready to Make Smarter Decisions?
            </span></h2>
            
            <p className="text-xl text-white/80 max-w-2xl mx-auto leading-relaxed" data-unique-id="5d2b740c-0dde-4b81-960f-7ba61b9439cd" data-file-name="components/final-cta-section.tsx"><span className="editable-text" data-unique-id="06de7d23-f8df-43f9-83c8-cbcd60672548" data-file-name="components/final-cta-section.tsx">
              Transform your business analysis into winning strategies with AI-powered insights. Start your free analysis today.
            </span></p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} viewport={{
          once: true
        }} className="flex flex-col sm:flex-row gap-4 justify-center" data-unique-id="9257279b-08e6-4f51-940f-8db1cb204f97" data-file-name="components/final-cta-section.tsx">
            <Link href="https://system.acumena.my.id/?newAnalysis=true" className="bg-white text-primary px-8 py-4 rounded-lg font-semibold text-lg inline-flex items-center justify-center gap-2 hover:bg-white/90 transition-all duration-300 hover:scale-105 group" data-unique-id="272c6b46-fa0c-40c7-9b8d-5d4f9397c342" data-file-name="components/final-cta-section.tsx"><span className="editable-text" data-unique-id="d5bedafa-2609-48d7-b4d4-0003f880f97e" data-file-name="components/final-cta-section.tsx">
              Try Acumena Now - It's Free
              </span><ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
            
            <button className="border-2 border-white/30 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white/10 transition-colors backdrop-blur-sm" data-unique-id="98645b52-2407-4b1f-af6e-6c1e5730cc55" data-file-name="components/final-cta-section.tsx"><span className="editable-text" data-unique-id="39587bd9-d414-4324-b262-b65d0a8a3b86" data-file-name="components/final-cta-section.tsx">
              Schedule Demo
            </span></button>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} viewport={{
          once: true
        }} className="flex items-center justify-center gap-8 text-sm text-white/60" data-unique-id="5a1e23d3-6135-41eb-ac1f-99fdd92b2171" data-file-name="components/final-cta-section.tsx">
            <div className="flex items-center gap-2" data-unique-id="a9125b26-e31c-4676-baf1-dd94bc9ab4f2" data-file-name="components/final-cta-section.tsx">
              <div className="w-2 h-2 bg-accent-green rounded-full" data-unique-id="999cc20c-19fb-4e4b-8a08-6b4225ea580a" data-file-name="components/final-cta-section.tsx"></div>
              <span data-unique-id="f3788dee-7471-44d8-aa81-f7e1ffa93478" data-file-name="components/final-cta-section.tsx"><span className="editable-text" data-unique-id="6fc8c99e-b638-4e62-93c2-b8396d094fd9" data-file-name="components/final-cta-section.tsx">No setup required</span></span>
            </div>
            <div className="flex items-center gap-2" data-unique-id="5252c466-4a2a-44de-b97d-a56bca95a7d8" data-file-name="components/final-cta-section.tsx">
              <div className="w-2 h-2 bg-accent-amber rounded-full" data-unique-id="8190fa31-6b5d-4aed-b812-dbab513dc097" data-file-name="components/final-cta-section.tsx"></div>
              <span data-unique-id="9ffb7ceb-bc9d-4bbb-a619-1e3a55487b59" data-file-name="components/final-cta-section.tsx"><span className="editable-text" data-unique-id="409cadbf-3b21-42aa-bf02-9662f8a90f4e" data-file-name="components/final-cta-section.tsx">Cancel anytime</span></span>
            </div>
            <div className="flex items-center gap-2" data-unique-id="293cb9c7-4744-42cf-9c2f-e424245358db" data-file-name="components/final-cta-section.tsx">
              <div className="w-2 h-2 bg-white rounded-full" data-unique-id="2f51b181-a6a9-4b24-96d7-54f5c1bbc332" data-file-name="components/final-cta-section.tsx"></div>
              <span data-unique-id="56313173-51f2-4e7c-8d83-0185e469ca96" data-file-name="components/final-cta-section.tsx"><span className="editable-text" data-unique-id="d4989af4-1065-4683-b6b4-197ef2a23f0d" data-file-name="components/final-cta-section.tsx">24/7 support</span></span>
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden" data-unique-id="97f7fd4b-5348-43ce-ab36-6bb9acc82194" data-file-name="components/final-cta-section.tsx">
        <motion.div animate={{
        rotate: [0, 360],
        scale: [1, 1.1, 1]
      }} transition={{
        duration: 20,
        repeat: Infinity,
        ease: "linear"
      }} className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-accent-green/20 to-transparent rounded-full" data-unique-id="5afa8f43-284d-4e84-9a0b-c1f46b4e7017" data-file-name="components/final-cta-section.tsx"></motion.div>
        <motion.div animate={{
        rotate: [360, 0],
        scale: [1, 1.2, 1]
      }} transition={{
        duration: 25,
        repeat: Infinity,
        ease: "linear"
      }} className="absolute -bottom-40 -left-40 w-96 h-96 bg-gradient-to-br from-accent-amber/20 to-transparent rounded-full" data-unique-id="554be543-83e7-448f-ae78-e78d11e6619d" data-file-name="components/final-cta-section.tsx"></motion.div>
      </div>
    </section>;
}